import { render, staticRenderFns } from "./invite_friend.vue?vue&type=template&id=5d55d101&scoped=true&"
import script from "./invite_friend.vue?vue&type=script&lang=js&"
export * from "./invite_friend.vue?vue&type=script&lang=js&"
import style0 from "./invite_friend.vue?vue&type=style&index=0&id=5d55d101&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55d101",
  null
  
)

export default component.exports